import { addZeroWidthSpaceAfterSlash } from '#/shared/utils/string';

/*
  This is a fragile criteria for getting a vanity name from a sign
  -- we're working a way to avoid doing this client-side
*/
export const parseSignVanityName = (fullSign, routeId) => {
  // TODO: this will need to be refactored when the TriMet web
  //  services are localized since its relying on a pattern that will
  //  only be present for English
  const trimetVanityName = fullSign.split(/\s(?:t|T)o\s/)[1];
  let vanityName;

  if (trimetVanityName) {
    vanityName = trimetVanityName;
  } else if (fullSign.startsWith('Portland Streetcar ')) {
    [, vanityName] = fullSign.split('Portland Streetcar ');
  } else {
    vanityName = (fullSign.split(String(routeId))[1] || fullSign || '').trim();
  }

  return addZeroWidthSpaceAfterSlash(vanityName);
};

export default parseSignVanityName;
